export default __webpack_public_path__ + "static/media/melanau_description.ac9541e0.png";